(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["xemantic-markdown-editor"] = factory();
	else
		root["xemantic-markdown-editor"] = factory();
})(globalThis, () => {
return 